import { toDate, useDateTimeFormat, type DateInput } from "@/shared/datetime";

/** "Oct 14, 2026": the header's dates use the short month. */
const SHORT_DATE = new Intl.DateTimeFormat(undefined, {
  month: "short",
  day: "numeric",
  year: "numeric",
});

interface EntityDateProps {
  /** When it happened. */
  value: DateInput;
}

/**
 * A date in a resource header's metadata strip: the day, in the viewer's date
 * format, with the full timestamp on hover.
 */
export function EntityDate({ value }: EntityDateProps) {
  const format = useDateTimeFormat();
  const date = toDate(value);
  if (date === null) {
    return null;
  }
  return (
    <time
      dateTime={date.toISOString()}
      title={format.format(date, { time: "seconds", timeZone: true })}
    >
      {SHORT_DATE.format(date)}
    </time>
  );
}
